import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { SELECT_FIELD_DEFAULT_VALUE } from '../../constants/settings';
import { useApplicationContext } from '../../contexts/ApplicationProvider';
import useServiceActions from '../../hooks/APIHooks/appointments/useServiceActions';
import { SelectData } from '../../types/common';
import SkillBadge from '../CommonComps/Badges/SkillBadge';
import AcademiaFormSelect from '../CommonComps/Inputs/AcademiaFormSelect';

// [MJA: MORE WORKS NEEDED TO BE DONE HERE WHEN APIs AND DATABASE IS UPDATED...]
const SelectExpertiseDiv = () => {
  // integration of react hooks here
  const [selectedService, setSelectedService] = useState<SelectData>(
    SELECT_FIELD_DEFAULT_VALUE
  );
  const [resetExpertiseField, setResetExpertiseField] =
    useState<boolean>(false);

  // integration of context hooks here
  const { selectedServices, setSelectedServices } = useApplicationContext();

  // integration of custom API hooks here
  const { getServiceListHandler } = useServiceActions('serviceList');

  // handler function to add new service declared here
  useEffect(() => {
    if (selectedService.id !== -1) {
      const existingService = selectedServices.find(
        (service) => service.id === selectedService.id
      );

      if (!existingService?.id) {
        setSelectedServices((state) => [
          ...state,
          {
            id: selectedService.id,
            name: selectedService.name,
          },
        ]);

        setSelectedService(SELECT_FIELD_DEFAULT_VALUE);
        setResetExpertiseField(true);
      } else {
        toast.warn('Skill Already Added!!');
      }
    }
  }, [selectedService, selectedServices, setSelectedServices]);

  const expertiseOptions = useMemo(() => {
    if (!getServiceListHandler.data?.is_success) return [];

    return getServiceListHandler.data.data
      .filter(
        (service) =>
          !selectedServices.some(
            (selectedService) => selectedService.id === service.id
          )
      )
      .map((service) => ({
        id: service.id,
        name: service.name,
      }));
  }, [getServiceListHandler.data, selectedServices]);

  // handler function to remove existing service from the list declared here
  const removeSelectedServiceHandler = (serviceId: number) => {
    setSelectedServices((state) =>
      state.filter((service) => service.id !== serviceId)
    );
  };

  // rendering select skills div component here
  return (
    <div>
      <AcademiaFormSelect
        name='field_of_expertise'
        label='Select Field of Expertise'
        options={expertiseOptions}
        defaultValue={selectedService}
        setValueOnChange={(value) => {
          setSelectedService(value);
          setResetExpertiseField(true);
        }}
        setResetSelectField={() => setResetExpertiseField(false)}
        resetSelectField={resetExpertiseField}
        showSearchInput
        isRequired
      />

      {selectedServices.length ? (
        <div className='flex flex-wrap gap-2 my-4 border-2 border-legal-dark-blue border-dashed rounded-md p-4'>
          {selectedServices.map((service) => (
            <SkillBadge
              key={service.id}
              badgeLabel={service.name}
              color='#1ABC9C'
              onClickRemove={() => {
                removeSelectedServiceHandler(service.id);
              }}
              isEditing
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SelectExpertiseDiv;
